import axios from "axios";

const baseUrl = "http://127.0.0.1:8000/";
const actualBaseUrl = "https://unmovers.herokuapp.com/";

export default axios.create({
  baseURL: actualBaseUrl,
});
